/**
 * Carries "your session expired" from the API client's 401 handling to the
 * login page (E05). The in-app redirect (ProtectedRoute answering `logout`)
 * cannot carry a reason, so a short-lived tab-scoped flag does; the hard
 * fallback also says `?reason=expired`.
 */
const KEY = 'graphit:session-expired'
export const SESSION_EXPIRED_REASON = 'expired'
export const SESSION_EXPIRED_MESSAGE = 'Your session expired. Sign in again to pick up where you left off.'

/**
 * Pages anyone can open without a session: a 401 there (a stale cookie
 * alongside a public share, embed, invitation, unsubscribe, verification or
 * reset link) must not flag an expiry, sign out or redirect. Prefix matches,
 * so `/verify-email` also covers `/verify-email-sent`.
 */
export const PUBLIC_PATH_PREFIXES = [
  '/login', '/signup', '/auth/', '/password-reset', '/reset-password',
  '/verify-email', '/shared/', '/embed/', '/invite/', '/unsubscribe/',
]

/**
 * @param {string} pathname
 * @returns {boolean} whether the page at this path is open without a session
 */
export function isPublicPath(pathname) {
  return PUBLIC_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))
}

export function markSessionExpired() {
  try { sessionStorage.setItem(KEY, '1') } catch { /* Storage may be unavailable; the redirect still works. */ }
}

/** @returns {boolean} whether the last sign-out was a session expiry */
export function isSessionExpired() {
  try { return sessionStorage.getItem(KEY) === '1' } catch { return false }
}

export function clearSessionExpired() {
  try { sessionStorage.removeItem(KEY) } catch { /* Optional browser storage. */ }
}
